<template>
  <div id="toggle-wrapper" :class="inputId">
    <div v-for="(radio, index) in radios" :key="index" class="toggle-radio-container">
      <input :id="`send-${radio.label}`"
            name="input_value"
            :ref="radio.ref"
            type="radio"
            :value="radio.value"
            v-model="radioSelection"
            @change="toggleRadioField" />
      <label :class="`radio radio-${index} text-center`" :for="`send-${radio.label}`">{{radio.label}}</label>
    </div>

    <div id="toggle-radio-input-value" :class="[inputId, { hide: hideInput, error: errorMessage }]">
      <label v-if="valueLabel" :for="inputId"> {{valueLabel}} </label>
      <span v-if="spanBeforeText"> {{spanBeforeText }} </span>
      <input class="form-control"
            :id="inputId"
            :name="inputId"
            type="number"
            v-model="inputValue"
            @blur="updateInteraction(true)"
            @change="setFrequency" />
      <span v-if="spanAfterText" > {{spanAfterText}} </span>
    </div>
    <small v-if="errorMessage" class="error-label">{{errorMessage}}</small>
  </div>
</template>

<script>

  export default {
    props: {
      inputId: [Number, String],
      radios: Array,
      savedInputValue: [Number, String],
      spanAfterText: String,
      spanBeforeText: String,
      valueLabel: String,
    },

    name: 'ToggleRadioInput',

    data() {
      return {
        errorMessage: null,
        inputValue: null,
        hideInput: null,
        noInteraction: true,
        radioSelection: null,
      }
    },

    methods: {
      configInteraction(isNoInput, noFrequency) {
        if (isNoInput) {
          this.noInteraction = false
        } else {
          this.noInteraction = noFrequency
        }
      },

      initCheckedRadio() {
        const parsedValue = parseInt(this.inputValue),
          isNoInput = parsedValue === -1,
          noFrequency = this.inputId === 'throttle' ? parsedValue < 7 : parsedValue < 1
        this.hideInput = isNoInput
        this.radioSelection = isNoInput ? -1 : ''
        this.configInteraction(isNoInput, noFrequency)
        if (this.inputId === 'throttle' && !isNoInput && parsedValue < 7 && !this.noInteraction) {
          this.inputValue = 0
          this.toggleError(true)
        } else if (!isNoInput && parsedValue < 1 && !this.noInteraction) {
          this.toggleError(true)
        }
      },

      setFrequency(event) {
        this.updateInteraction()
        this.validateFrequency(parseInt(event.currentTarget.value))
      },

      toggleError(showError) {
        // fix this in future to be more dynamic
        if (this.inputId === 'throttle') {
          this.errorMessage = showError ? 'must be 7 or greater' : null
        } else if (this.inputId === 'argument_3') {
          this.errorMessage = showError ? 'must be greater than 0' : null
        }
        this.$emit('setErrors', this.inputId, this.errorMessage)
      },

      toggleRadioField(event) {
        const inputValue = parseInt(event.target.value),
          isNoInput = inputValue === -1,
          previousValue = parseInt(this.savedInputValue)
        this.hideInput = isNoInput
        if (isNoInput) {
          this.updateInteraction()
          this.toggleError()
          if (inputValue !== previousValue) { this.$emit('updateSettings', { [this.inputId]: inputValue }) }
        } else {
          this.inputValue = 0
          this.toggleError(true)
        }
      },

      updateInteraction(validate) {
        if (this.noInteraction) {
          this.noInteraction = false
          this.$emit('setInteractions', this.inputId)
          if (validate) { this.validateFrequency(null, true) }
        }
      },

      validateFrequency(inputValue, noUpdate) {
        this.noInteraction = false
        const prevValue = parseInt(this.savedInputValue),
          value = inputValue ? inputValue : prevValue,
          validThrottle = this.inputId === 'throttle' && inputValue >= 7,
          validArgument = this.savedInputValue !== 'throttle' && inputValue >= 1

        if (validThrottle || validArgument) {
          this.toggleError()
          if (noUpdate) { return }
          if (value !== prevValue) { this.$emit('updateSettings', { [this.inputId]: inputValue }) }
        } else {
          this.toggleError(true)
        }
      },
    },

    created() {
      this.inputValue = this.savedInputValue
      this.initCheckedRadio()
    },

    watch: {
      savedInputValue: function () {
        this.inputValue = this.savedInputValue
      },
    }
  }
</script>